<template>
<div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12 col-xl-12" style="margin-top: 20px;">
                <div class="card">
                    <div class="card-header">
                        <CfdiFiltersBar style="float: right; font-size: 12px; padding: 2px 10px" v-model="filters" :nature="nature" :group="tab" :showSearch="true" :showPeriod="false" :showAdvanced="true" :showStatus="true" :showMethod="true" :showExport="true" :showDownload="true" :downloadLoading="requestingFilesDownload" :showPersonalDeductions="true" @apply="refreshItems" @export="exportCfdis" @download="requestCfdiFilesDownload"/>
                        <h3>CFDIs Recibidos</h3>
                    </div>
                    <div class="card-body">
                        <div class="row kpi-row">
                            <div :class="kpiColumnClass()">
                                <div
                                    ref="firstKpiPopoverBtn"
                                    class="kpi-card kpi-card-hoverable kpi-card--primary"
                                    @mouseenter="onFirstKpiMouseEnter"
                                    @mouseleave="onFirstKpiMouseLeave"
                                >
                                    <div class="kpi-card-top">
                                        <div>
                                            <div class="kpi-title">CFDIs Recibidos</div>
                                            <div class="kpi-value" :style="kpiValueStyle(kpis.received_total)">{{ formatCurrency(kpis.received_total) }}</div>
                                        </div>
                                    </div>
                                    <div class="kpi-footnote">Total facturado</div>
                                    <div v-if="kpisLoading" class="kpi-loading-note">Actualizando...</div>
                                </div>
                            </div>
                            <div :class="kpiColumnClass()">
                                <div
                                    ref="secondKpiPopoverBtn"
                                    class="kpi-card kpi-card-hoverable kpi-card--success"
                                    @mouseenter="onSecondKpiMouseEnter"
                                    @mouseleave="onSecondKpiMouseLeave"
                                >
                                    <div class="kpi-card-top">
                                        <div>
                                            <div class="kpi-title">CFDIs Pagados</div>
                                            <div class="kpi-value" :style="kpiValueStyle(kpis.paid_total)">{{ formatCurrency(kpis.paid_total) }}</div>
                                        </div>
                                    </div>
                                    <div class="kpi-footnote">Total pagado</div>
                                    <div v-if="kpisLoading" class="kpi-loading-note">Actualizando...</div>
                                </div>
                            </div>
                            <div :class="kpiColumnClass()">
                                <div
                                    ref="thirdKpiPopoverBtn"
                                    class="kpi-card kpi-card-hoverable kpi-card--info"
                                    @mouseenter="onThirdKpiMouseEnter"
                                    @mouseleave="onThirdKpiMouseLeave"
                                >
                                    <div class="kpi-card-top">
                                        <div>
                                            <div class="kpi-title">IVA Acreditable</div>
                                            <div class="kpi-value" :style="kpiValueStyle(kpis.iva_acreditable)">{{ formatCurrency(kpis.iva_acreditable) }}</div>
                                        </div>
                                    </div>
                                    <div class="kpi-footnote">IVA acumulado</div>
                                    <div v-if="kpisLoading" class="kpi-loading-note">Actualizando...</div>
                                </div>
                            </div>
                            <div v-if="shouldShowRetainedKpi()" :class="kpiColumnClass()">
                                <div
                                    ref="fourthKpiPopoverBtn"
                                    class="kpi-card kpi-card-hoverable kpi-card--warning"
                                    @mouseenter="onFourthKpiMouseEnter"
                                    @mouseleave="onFourthKpiMouseLeave"
                                >
                                    <div class="kpi-card-top">
                                        <div>
                                            <div class="kpi-title">Impuestos retenidos</div>
                                            <div class="kpi-value" :style="kpiValueStyle(kpis.impuestos_retenidos)">{{ formatCurrency(kpis.impuestos_retenidos) }}</div>
                                        </div>
                                    </div>
                                    <div class="kpi-footnote">Total de retenciones</div>
                                    <div v-if="kpisLoading" class="kpi-loading-note">Actualizando...</div>
                                </div>
                            </div>
                            <div v-if="shouldShowPayrollKpi()" :class="kpiColumnClass()">
                                <div class="kpi-card kpi-card--payroll">
                                    <div class="kpi-card-top">
                                        <div>
                                            <div class="kpi-title">CFDIs de Nómina</div>
                                            <div class="kpi-value" :style="kpiValueStyle(kpis.payroll_total)">{{ formatCurrency(kpis.payroll_total) }}</div>
                                        </div>
                                    </div>
                                    <div class="kpi-footnote">Total acumulado</div>
                                </div>
                            </div>
                        </div>

                        <div class="table-responsive creditable-breakdown-wrapper" style="margin-bottom: 14px;">
                            <table class="table table-sm creditable-breakdown-table mb-0">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th class="text-end">CFDIs</th>
                                        <th class="text-end">Total<br />CFDIs</th>
                                        <th class="text-end">Base<br />IVA 16%</th>
                                        <th class="text-end">Base<br />IVA 8%</th>
                                        <th class="text-end">Base<br />IVA 0%</th>
                                        <th class="text-end">Base<br />IVA exento</th>
                                        <th class="text-end">IVA acreditable<br />16%</th>
                                        <th class="text-end">IVA acreditable<br />8%</th>
                                        <th class="text-end">IVA acreditable<br />Total</th>
                                        <th class="text-end">Retenciones<br />IVA</th>
                                        <th class="text-end">Retenciones<br />ISR</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="creditableBreakdownLoading">
                                        <td colspan="12" class="text-center">Cargando desglose de IVA acreditable...</td>
                                    </tr>
                                    <tr v-else-if="creditableBreakdownError">
                                        <td colspan="12" class="text-center text-danger">{{ creditableBreakdownError }}</td>
                                    </tr>
                                    <tr v-else-if="!creditableBreakdownRows.length">
                                        <td colspan="12" class="text-center">No hay datos para el periodo seleccionado.</td>
                                    </tr>
                                    <tr v-for="row in creditableBreakdownRows" :key="row.key" :class="{ 'is-total-row': row.key === 'totals' }">
                                        <td>{{ row.label }}</td>
                                        <td class="text-end">{{ formatInteger(row.cfdis_count) }}</td>
                                        <td class="text-end">{{ formatCurrency(row.total_cfdis) }}</td>
                                        <td class="text-end">{{ formatCurrency(row.base_iva_16) }}</td>
                                        <td class="text-end">{{ formatCurrency(row.base_iva_8) }}</td>
                                        <td class="text-end">{{ formatCurrency(row.base_iva_0) }}</td>
                                        <td class="text-end">{{ formatCurrency(row.base_iva_exento) }}</td>
                                        <td class="text-end">{{ formatCurrency(row.iva_16) }}</td>
                                        <td class="text-end">{{ formatCurrency(row.iva_8) }}</td>
                                        <td class="text-end creditable-total-cell">{{ formatCurrency(row.iva_acreditable_total) }}</td>
                                        <td class="text-end">{{ formatCurrency(row.retenciones_iva) }}</td>
                                        <td class="text-end">{{ formatCurrency(row.retenciones_isr) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <br />
                        <button v-if="cfdis.length > 0" class="btn btn-sm btn-outline-secondary" @click="showColumns" style="float: right; margin: 0px; position: absolute; right: 30px">
                            <i class="fa fa-sliders"></i> Editar Columnas
                        </button>
                        <ul class="nav nav-tabs border-tab" id="top-tab" role="tablist">
                            <li class="nav-item"><a @click="changeTab('incomes')" class="nav-link active" id="top-incomes-tab" data-bs-toggle="tab" href="#top-incomes" role="tab" aria-controls="top-incomes" aria-selected="true"><i class="icofont icofont-ui-home"></i>Ingreso ({{ counters.I ? counters.I : 0 }})</a></li>
                            <li class="nav-item"><a @click="changeTab('expenses')" class="nav-link" id="expenses-top-tab" data-bs-toggle="tab" href="#top-expenses" role="tab" aria-controls="top-expenses" aria-selected="false"><i class="icofont icofont-man-in-glasses"></i>Egreso ({{ counters.I ? counters.E : 0 }})</a></li>
                            <li class="nav-item"><a @click="changeTab('payments')" class="nav-link" id="payments-top-tab" data-bs-toggle="tab" href="#top-payments" role="tab" aria-controls="top-payments" aria-selected="false"><i class="icofont icofont-contacts"></i>Pagos ({{ counters.I ? counters.P : 0 }})</a></li>
                            <li v-if="hasPayrollCfdis()" class="nav-item"><a @click="changeTab('payrolls')" class="nav-link" id="payrolls-top-tab" data-bs-toggle="tab" href="#top-payrolls" role="tab" aria-controls="top-payrolls" aria-selected="false"><i class="icofont icofont-contacts"></i>Nómina ({{ counters.I ? counters.N : 0 }})</a></li>
                        </ul>
                        <div class="tab-content" id="top-tabContent">
                            <div v-if="listLoading" class="text-center py-2 small text-muted">
                                <i class="fa fa-spinner fa-spin me-1"></i>Cargando listado...
                            </div>
                            <div class="tab-pane fade show active" id="top-incomes" role="tabpanel" aria-labelledby="top-incomes-tab">
                                <CfdiTable :items="cfdis" :fields="fields" empty-text="No se encontraron CFDIs de ingreso en el periodo seleccionado."/>
                            </div>
                            <div class="tab-pane fade" id="top-expenses" role="tabpanel" aria-labelledby="expenses-top-tab">
                                <CfdiTable :items="cfdis" :fields="fields" empty-text="No se encontraron CFDIs de egreso en el periodo seleccionado."/>
                            </div>
                            <div class="tab-pane fade" id="top-payments" role="tabpanel" aria-labelledby="payments-top-tab">
                                <CfdiTable :items="cfdis" :fields="fields" empty-text="No se encontraron CFDIs de pago en el periodo seleccionado."/>
                            </div>
                            <div v-if="hasPayrollCfdis()" class="tab-pane fade" id="top-payrolls" role="tabpanel" aria-labelledby="payrolls-top-tab">
                                <CfdiTable :items="cfdis" :fields="fields" empty-text="No se encontraron CFDIs de nómina en el periodo seleccionado."/>
                            </div>
                        </div>
                        <ul class="pagination pagination-sm pagination-primary" style="margin-top: 10px; float: right;" v-if="paginator.total_pages > 1">
                            <li class="page-item"><a class="page-link" :style="paginator.current_page == 1 ? 'color: gray !important' : ''" href="javascript:void(0)" @click="paginator.current_page > 1 && changePage(paginator.current_page - 1)">Anterior</a></li>
                            <li class="page-item" v-for="page in pagesToShow" :key="page" @click="paginator.current_page != page && changePage(page)"><a class="page-link" href="javascript:void(0)">{{ page }}</a></li>
                            <li class="page-item"><a class="page-link" :style="paginator.current_page == paginator.total_pages ? 'color: gray !important' : ''" href="javascript:void(0)" @click="paginator.current_page < paginator.total_pages && changePage(paginator.current_page + 1)">Siguiente</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal -->
    <ColumnsConfigModal
        ref="configColumnsModal"
        v-if="showColumnsModal"
        :columns="fields"
        @close="showColumnsModal = false"
        @save="onColumnsSave"
    />

    <teleport to="body">
        <div
            v-if="kpiDetailModal.visible"
            class="modal fade show d-block"
            tabindex="-1"
            role="dialog"
            aria-modal="true"
            @click.self="closeKpiDetailModal"
        >
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ kpiDetailModal.title }}</h5>
                        <button type="button" class="btn-close" aria-label="Cerrar" @click="closeKpiDetailModal"></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="kpiDetailModal.loading" class="text-center py-4">
                            <i class="fa fa-spinner fa-spin me-2"></i>Cargando detalle...
                        </div>
                        <div v-else-if="kpiDetailModal.error" class="alert alert-danger mb-0">{{ kpiDetailModal.error }}</div>
                        <div v-else-if="!kpiDetailModal.rows.length" class="text-center py-4 text-muted">No se encontraron CFDIs para este desglose.</div>
                        <div v-else class="table-responsive">
                            <table class="table table-sm table-hover mb-0">
                                <thead>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>UUID CFDI</th>
                                        <th>UUID Pago</th>
                                        <th>Método</th>
                                        <th>RFC contraparte</th>
                                        <th>Nombre contraparte</th>
                                        <th class="text-end">Monto</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row, idx) in kpiDetailModal.rows" :key="`${row.uuid_cfdi || 'none'}-${row.uuid_pago || 'none'}-${idx}`">
                                        <td>{{ row.fecha }}</td>
                                        <td>{{ row.uuid_cfdi || '-' }}</td>
                                        <td>{{ row.uuid_pago || '-' }}</td>
                                        <td>{{ row.metodo_pago || '-' }}</td>
                                        <td>{{ row.counterpart_rfc || '-' }}</td>
                                        <td>{{ row.counterpart_name || '-' }}</td>
                                        <td class="text-end">{{ formatCurrency(row.monto_calculo) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" @click="closeKpiDetailModal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="kpiDetailModal.visible" class="modal-backdrop fade show"></div>
    </teleport>
</div>
</template>
<style lang="css">
    .currency{
        text-align: right;
    }

    .popover.kpi-breakdown-popover,
    .popover.kpi-paid-breakdown-popover,
    .popover.kpi-iva-breakdown-popover,
    .popover.kpi-retained-breakdown-popover{
        --bs-popover-max-width: 760px !important;
        --bs-popover-border-color: rgba(22, 36, 58, 0.42) !important;
        --bs-popover-header-bg: #f4f8ff !important;
        --bs-popover-header-color: #1a2a44 !important;
        --bs-popover-body-color: #22324d !important;
        --bs-popover-box-shadow: 0 18px 40px rgba(16, 24, 40, 0.30), 0 6px 14px rgba(16, 24, 40, 0.18) !important;
        max-width: 760px !important;
        min-width: 700px !important;
        border: 2px solid rgba(22, 36, 58, 0.38) !important;
        border-radius: 12px !important;
        box-shadow: 0 18px 40px rgba(16, 24, 40, 0.30), 0 6px 14px rgba(16, 24, 40, 0.18) !important;
    }

    .popover.kpi-breakdown-popover .popover-header,
    .popover.kpi-paid-breakdown-popover .popover-header,
    .popover.kpi-iva-breakdown-popover .popover-header,
    .popover.kpi-retained-breakdown-popover .popover-header{
        border-bottom: 1px solid rgba(22, 36, 58, 0.18) !important;
        font-weight: 700;
    }

    .popover.kpi-breakdown-popover .popover-body,
    .popover.kpi-paid-breakdown-popover .popover-body,
    .popover.kpi-iva-breakdown-popover .popover-body,
    .popover.kpi-retained-breakdown-popover .popover-body{
        border-top: 1px solid rgba(22, 36, 58, 0.08);
    }
</style>
<script>
import ColumnsConfigModal from "@/components/cfdis/ColumnsConfigModal.vue";
import CfdiFiltersBar from "@/components/cfdis/CfdiFiltersBar.vue";
import CfdiTable from "@/components/cfdis/CfdiTable.vue";
import Popover from 'bootstrap/js/dist/popover';

import ws from '@/services/cfdis'
import accountService from '@/services/account'
import dashboardService from '@/services/dashboard'
import { getGlobalPeriod } from '@/services/globalPeriod';

export default {
    components: {
        CfdiFiltersBar,
        CfdiTable,
        ColumnsConfigModal
    },
    data() {
        return {
            rfc: '',
            period: '',
            nature: 'received',
            groups: ['incomes', 'expenses', 'payments', 'payrolls'],
            tab: 'incomes',
            filters: {
                rfc: '',
                nature: '',
                group: '',
                period: "",
                search: "",
                status: "1",
                method: "ALL",
                personal_deductions: false,
                advanced: [],
            },
            cfdis: [],
            fields: [],
            counters: [],
            viewportWidth: window.innerWidth,

            paginator: {
                current_page: 1,
                per_page: 30,
                total_pages: 1,
                total_items: 0,
            },

            pending_downloads: false,
            showColumnsModal: false,
            listLoading: false,
            kpisLoading: false,
            requestingFilesDownload: false,
            creditableBreakdownLoading: false,
            creditableBreakdownError: '',
            creditableBreakdownRows: [],
            firstKpiPopover: null,
            secondKpiPopover: null,
            thirdKpiPopover: null,
            fourthKpiPopover: null,
            firstKpiHideTimeout: null,
            secondKpiHideTimeout: null,
            thirdKpiHideTimeout: null,
            fourthKpiHideTimeout: null,
            kpiDetailModal: {
                visible: false,
                loading: false,
                title: '',
                error: '',
                rows: [],
            },
            kpis: {
                received_cfdis: 0,
                received_total: 0,
                paid_cfdis: 0,
                paid_total: 0,
                iva_acreditable: 0,
                impuestos_retenidos: 0,
                impuestos_retenidos_breakdown: {
                    total: 0,
                    rows: [],
                },
                payroll_cfdis: 0,
                payroll_total: 0,
                paid_iva_breakdown: {
                    iva_16_total: 0,
                    iva_8_total: 0,
                    retenciones_iva_total: 0,
                    net_total: 0,
                    income_pue: {
                        iva_16: 0,
                        iva_8: 0,
                        retenciones_iva: 0,
                        net_total: 0,
                    },
                    payments: {
                        iva_16: 0,
                        iva_8: 0,
                        retenciones_iva: 0,
                        net_total: 0,
                    },
                    credit_notes: {
                        iva_16: 0,
                        iva_8: 0,
                        retenciones_iva: 0,
                        net_total: 0,
                    },
                },
                paid_total_breakdown: {
                    income_pue_cfdis: 0,
                    income_pue_total: 0,
                    payments_cfdis: 0,
                    payments_total: 0,
                    credit_notes_cfdis: 0,
                    credit_notes_total: 0,
                    net_cfdis: 0,
                    net_total: 0,
                },
                main_total_breakdown: {
                    income_pue_cfdis: 0,
                    income_pue_total: 0,
                    income_ppd_cfdis: 0,
                    income_ppd_total: 0,
                    credit_notes_cfdis: 0,
                    credit_notes_total: 0,
                    net_cfdis: 0,
                    net_total: 0,
                }
            }
        }
    },
    mounted: async function() {
        this.listLoading = true;
        this.kpisLoading = true;
        this.creditableBreakdownLoading = true;

        this.rfc =  localStorage.getItem('rfc');
        this.period = getGlobalPeriod();

        this.filters.rfc = this.rfc;
        this.filters.period = this.period;
        this.filters.nature = this.nature;
        this.filters.group = this.tab;

        await this.refreshFields();
        await Promise.all([
            this.refreshListSection(),
            this.refreshBreakdownSection(),
            this.refreshKpisSection(),
        ]);

        document.addEventListener('click', this.handleKpiPopoverOutsideClick);
        document.addEventListener('click', this.handleKpiPopoverAmountClick);
        window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleKpiPopoverOutsideClick);
        document.removeEventListener('click', this.handleKpiPopoverAmountClick);
        window.removeEventListener('resize', this.handleResize);
        this.clearKpiHideTimeouts();
        this.disposeFirstKpiPopover();
        this.disposeSecondKpiPopover();
        this.disposeThirdKpiPopover();
        this.disposeFourthKpiPopover();
    },
    methods: {
        escapeHtml(value){
            return String(value ?? '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
        },
        renderKpiAmountButton(detailKey, label, amount, sign = '+'){
            const safeLabel = this.escapeHtml(label);
            const safeKey = this.escapeHtml(detailKey);
            const signText = sign === '-' ? '-' : '+';

            return `<button type="button" class="kpi-popover-amount-btn" data-detail-key="${safeKey}" data-detail-title="${safeLabel}" style="float: right; border: 0; background: transparent; padding: 0; color: inherit; font-weight: 700; text-decoration: underline;">${signText} ${this.formatCurrency(amount)}</button>`;
        },
        formatSignedCurrency(value, sign = '+', includePlus = false){
            const numeric = Math.abs(Number(value || 0));
            if(sign === '-'){
                return `- ${this.formatCurrency(numeric)}`;
            }

            if(includePlus){
                return `+ ${this.formatCurrency(numeric)}`;
            }

            return this.formatCurrency(numeric);
        },
        renderKpiBreakdownTable(rows, totals, options = {}){
            const interactiveTotals = options.interactiveTotals === true;
            const rowsHtml = rows
                .filter((row) => Number(row?.total || 0) !== 0)
                .map((row) => {
                    const sign = row?.sign === '-' ? '-' : '+';
                    const subtotalText = this.formatSignedCurrency(row.subtotal, sign);
                    const transferredText = this.formatSignedCurrency(row.transferred, sign);
                    const retainedText = this.formatSignedCurrency(row.retained, sign);
                    const totalCell = interactiveTotals
                        ? this.renderKpiAmountButton(row.detailKey, row.detailTitle, Math.abs(Number(row.total || 0)), sign)
                        : `<strong>${this.formatSignedCurrency(row.total, sign)}</strong>`;

                    return `
                        <tr class="${sign === '-' ? 'is-negative' : ''}">
                            <td>${this.escapeHtml(row.label)}</td>
                            <td class="text-end">${subtotalText}</td>
                            <td class="text-end">${transferredText}</td>
                            <td class="text-end">${retainedText}</td>
                            <td class="text-end">${totalCell}</td>
                        </tr>
                    `;
                })
                .join('');

            return `
                <div class="kpi-popover-content" style="min-width: 520px;">
                    <table class="table table-sm kpi-popover-table mb-0">
                        <thead>
                            <tr>
                                <th>Concepto</th>
                                <th class="text-end">Subtotal</th>
                                <th class="text-end">Trasladados</th>
                                <th class="text-end">Retenidos</th>
                                <th class="text-end">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${rowsHtml || '<tr><td colspan="5" class="text-center text-muted">Sin movimientos en este desglose.</td></tr>'}
                        </tbody>
                        <tfoot>
                            <tr>
                                <th>Totales</th>
                                <th class="text-end">${this.formatCurrency(totals.subtotal || 0)}</th>
                                <th class="text-end">${this.formatCurrency(totals.transferred || 0)}</th>
                                <th class="text-end">${this.formatCurrency(totals.retained || 0)}</th>
                                <th class="text-end">${this.formatCurrency(totals.total || 0)}</th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            `;
        },
        async openKpiDetailModal(detailKey, detailTitle){
            this.disposeFirstKpiPopover();
            this.disposeSecondKpiPopover();
            this.disposeThirdKpiPopover();

            // Always align detail requests with the current global period.
            this.filters.period = getGlobalPeriod();
            this.period = this.filters.period;

            this.kpiDetailModal.visible = true;
            this.kpiDetailModal.loading = true;
            this.kpiDetailModal.title = detailTitle || 'Detalle de desglose';
            this.kpiDetailModal.error = '';
            this.kpiDetailModal.rows = [];

            try{
                const response = await ws.getReceivedKpiDetail(this.rfc, this.filters, detailKey);
                if(response && response.type === 'success'){
                    this.kpiDetailModal.rows = this.sortKpiDetailRowsByUuid(response?.data?.rows || []);
                }
                else{
                    this.kpiDetailModal.error = response?.message || 'No fue posible cargar el detalle.';
                }
            }
            catch(error){
                this.kpiDetailModal.error = error?.response?.data?.message || 'No fue posible cargar el detalle.';
            }
            finally{
                this.kpiDetailModal.loading = false;
            }
        },
        sortKpiDetailRowsByUuid(rows){
            return [...(rows || [])].sort((a, b) => {
                const uuidA = String(a?.uuid_cfdi || '').trim().toUpperCase();
                const uuidB = String(b?.uuid_cfdi || '').trim().toUpperCase();

                if(uuidA === uuidB){
                    return 0;
                }

                if(uuidA === ''){
                    return 1;
                }

                if(uuidB === ''){
                    return -1;
                }

                return uuidA.localeCompare(uuidB, 'es', { sensitivity: 'base' });
            });
        },
        closeKpiDetailModal(){
            this.kpiDetailModal.visible = false;
            this.kpiDetailModal.loading = false;
            this.kpiDetailModal.error = '';
            this.kpiDetailModal.rows = [];
            this.kpiDetailModal.title = '';
        },
        handleKpiPopoverAmountClick(event){
            const target = event.target?.closest?.('.kpi-popover-amount-btn');
            if(!target){
                return;
            }

            const detailKey = target.getAttribute('data-detail-key') || '';
            const detailTitle = target.getAttribute('data-detail-title') || 'Detalle de desglose';

            if(!detailKey){
                return;
            }

            event.preventDefault();
            event.stopPropagation();

            this.openKpiDetailModal(detailKey, detailTitle);
        },
        clearKpiHideTimeouts() {
            this.cancelFirstKpiHide();
            this.cancelSecondKpiHide();
            this.cancelThirdKpiHide();
            this.cancelFourthKpiHide();
        },
        onFirstKpiMouseEnter() {
            this.cancelFirstKpiHide();
            this.toggleFirstKpiPopover();
        },
        onFirstKpiMouseLeave() {
            this.scheduleFirstKpiHide();
        },
        scheduleFirstKpiHide() {
            this.cancelFirstKpiHide();
            this.firstKpiHideTimeout = setTimeout(() => {
                this.disposeFirstKpiPopover();
            }, 120);
        },
        cancelFirstKpiHide() {
            if(this.firstKpiHideTimeout){
                clearTimeout(this.firstKpiHideTimeout);
                this.firstKpiHideTimeout = null;
            }
        },
        onSecondKpiMouseEnter() {
            this.cancelSecondKpiHide();
            this.toggleSecondKpiPopover();
        },
        onSecondKpiMouseLeave() {
            this.scheduleSecondKpiHide();
        },
        scheduleSecondKpiHide() {
            this.cancelSecondKpiHide();
            this.secondKpiHideTimeout = setTimeout(() => {
                this.disposeSecondKpiPopover();
            }, 120);
        },
        cancelSecondKpiHide() {
            if(this.secondKpiHideTimeout){
                clearTimeout(this.secondKpiHideTimeout);
                this.secondKpiHideTimeout = null;
            }
        },
        onThirdKpiMouseEnter() {
            this.cancelThirdKpiHide();
            this.toggleThirdKpiPopover();
        },
        onThirdKpiMouseLeave() {
            this.scheduleThirdKpiHide();
        },
        scheduleThirdKpiHide() {
            this.cancelThirdKpiHide();
            this.thirdKpiHideTimeout = setTimeout(() => {
                this.disposeThirdKpiPopover();
            }, 120);
        },
        cancelThirdKpiHide() {
            if(this.thirdKpiHideTimeout){
                clearTimeout(this.thirdKpiHideTimeout);
                this.thirdKpiHideTimeout = null;
            }
        },
        onFourthKpiMouseEnter() {
            this.cancelFourthKpiHide();
            this.toggleFourthKpiPopover();
        },
        onFourthKpiMouseLeave() {
            this.scheduleFourthKpiHide();
        },
        scheduleFourthKpiHide() {
            this.cancelFourthKpiHide();
            this.fourthKpiHideTimeout = setTimeout(() => {
                this.disposeFourthKpiPopover();
            }, 120);
        },
        cancelFourthKpiHide() {
            if(this.fourthKpiHideTimeout){
                clearTimeout(this.fourthKpiHideTimeout);
                this.fourthKpiHideTimeout = null;
            }
        },
        handleResize() {
            this.viewportWidth = window.innerWidth;
        },
        async changeTab(tab) {
            if(tab === 'payrolls' && !this.hasPayrollCfdis()){
                tab = 'incomes';
            }

            this.tab = tab;
            this.filters.group = tab;

            this.paginator.current_page = 1;
            this.listLoading = true;

            await this.refreshFields();
            await this.refreshListSection();
        },
        async changePage(val) {
            this.paginator.current_page = val;

            this.refreshListSection();
        },
        async showColumns(){            
            this.showColumnsModal = true;
        },
        async refreshFields(){
            let response = await ws.getFields(this.nature, this.tab);

            if(response && response.type == "success"){
                this.fields = response.data;
            }
        },
        async refreshItems(){
            // Always align listing/KPI requests with the current global period.
            this.filters.period = getGlobalPeriod();
            this.period = this.filters.period;
            this.listLoading = true;
            this.kpisLoading = true;

            // Clear previous breakdown values immediately so stale period data is not shown.
            this.creditableBreakdownError = '';
            this.creditableBreakdownRows = this.getEmptyCreditableBreakdownRows();
            this.creditableBreakdownLoading = true;

            await Promise.all([
                this.refreshListSection(),
                this.refreshBreakdownSection(),
                this.refreshKpisSection(),
            ]);
        },
        async refreshListSection(){
            this.listLoading = true;
            try {
                const cfdisResponse = await ws.getReceivedCfdis(this.rfc, this.filters, this.paginator.current_page, {
                    include_kpis: false,
                    include_totals: false,
                });

                if(cfdisResponse && cfdisResponse.type == "success"){
                    this.cfdis = cfdisResponse.data;
                    this.counters = cfdisResponse.counters;
                    this.pending_downloads = cfdisResponse.downloads;

                    this.disposeFirstKpiPopover();
                    this.disposeSecondKpiPopover();
                    this.disposeThirdKpiPopover();
                    this.disposeFourthKpiPopover();

                    if(this.tab === 'payrolls' && !this.hasPayrollCfdis()){
                        await this.changeTab('incomes');
                        return;
                    }

                    if(this.pending_downloads && this.$refs.pendingDownloadsIndicator && typeof this.$refs.pendingDownloadsIndicator.restart === 'function'){
                        this.$refs.pendingDownloadsIndicator.restart();
                    }

                    this.counter = this.cfdis.length;

                    let items = 0;
                    if(this.tab == "incomes") items = this.counters.I;
                    if(this.tab == "expenses") items = this.counters.E;
                    if(this.tab == "payments") items = this.counters.P;
                    if(this.tab == "payrolls") items = this.counters.N;

                    this.paginator = {
                        current_page: this.paginator.current_page,
                        per_page: this.paginator.per_page,
                        total_pages: Math.ceil(items / this.paginator.per_page),
                        total_items: items,
                    };
                }
            } finally {
                this.listLoading = false;
            }
        },
        async refreshBreakdownSection(){
            this.creditableBreakdownLoading = true;
            this.creditableBreakdownError = '';

            try {
                const creditableBreakdownResponse = await ws.getCreditableBreakdown(this.rfc, this.filters).catch(() => null);

                if(creditableBreakdownResponse && creditableBreakdownResponse.type == 'success'){
                    this.creditableBreakdownRows = (creditableBreakdownResponse?.data?.rows ?? []).length
                        ? creditableBreakdownResponse.data.rows
                        : this.getEmptyCreditableBreakdownRows();
                }
                else{
                    this.creditableBreakdownRows = this.getEmptyCreditableBreakdownRows();
                }
            } finally {
                this.creditableBreakdownLoading = false;
            }
        },
        async refreshKpisSection(){
            this.kpisLoading = true;
            try {
                const response = await ws.getReceivedKpis(this.rfc, this.filters).catch(() => null);

                if(response && response.type === 'success' && response.kpis){
                    this.kpis = {
                        received_cfdis: Number(response?.kpis?.received_cfdis ?? 0),
                        received_total: Number(response?.kpis?.received_total ?? 0),
                        paid_cfdis: Number(response?.kpis?.paid_cfdis ?? 0),
                        paid_total: Number(response?.kpis?.paid_total ?? 0),
                        iva_acreditable: Number(response?.kpis?.iva_acreditable ?? 0),
                        impuestos_retenidos: Number(response?.kpis?.impuestos_retenidos ?? 0),
                        impuestos_retenidos_breakdown: response?.kpis?.impuestos_retenidos_breakdown || this.kpis.impuestos_retenidos_breakdown,
                        payroll_cfdis: Number(response?.kpis?.payroll_cfdis ?? 0),
                        payroll_total: Number(response?.kpis?.payroll_total ?? 0),
                        paid_iva_breakdown: response?.kpis?.paid_iva_breakdown || this.kpis.paid_iva_breakdown,
                        paid_total_breakdown: response?.kpis?.paid_total_breakdown || this.kpis.paid_total_breakdown,
                        main_total_breakdown: response?.kpis?.main_total_breakdown || this.kpis.main_total_breakdown,
                    };
                }
            } finally {
                this.kpisLoading = false;
            }
        },
        emptyBreakdownRow(key, label){
            return {
                key,
                label,
                cfdis_count: 0,
                total_cfdis: 0,
                base_iva_16: 0,
                base_iva_8: 0,
                base_iva_0: 0,
                base_iva_exento: 0,
                iva_16: 0,
                iva_8: 0,
                iva_acreditable_total: 0,
                retenciones_iva: 0,
                retenciones_isr: 0,
            };
        },
        getEmptyCreditableBreakdownRows(){
            return [
                this.emptyBreakdownRow('cash', 'Facturas de contado'),
                this.emptyBreakdownRow('credit_invoices', 'Facturas a credito'),
                this.emptyBreakdownRow('credit', 'Pago facturas de credito'),
                this.emptyBreakdownRow('credit_notes', 'Notas de credito'),
            ];
        },
        async ensureDownloadsEnabled() {
            try {
                const response = await accountService.getSubscription();
                const status = response?.data?.status || null;

                const history = await dashboardService.getDownloadCenterHistory(this.rfc, 1, 1, { skipLoading: true });
                const efirmaIncident = history?.efirma_incident || null;

                if (efirmaIncident) {
                    this.$toast.error(efirmaIncident?.warning_message || 'Las descargas de CFDIs están suspendidas hasta actualizar la e.firma.');
                    return false;
                }

                if (status && !status.can_request_downloads) {
                    this.$toast.error(status?.warning?.message || 'Tu suscripción no está vigente. Renueva tu paquete para reactivar descargas.');
                    return false;
                }
            } catch (error) {
                // Backend keeps final enforcement even if precheck fails.
            }

            return true;
        },
        async download() {
            const enabled = await this.ensureDownloadsEnabled();
            if(!enabled){
                return;
            }

            let response = await ws.downloadCfdis(this.rfc, this.period); 

            if(response && response.type == "success"){
                this.pending_downloads = true;

                this.$toast.success(response.message);
            }
            else{
                this.$toast.error(response.message);
            }
        },
        async requestCfdiFilesDownload() {
            if(this.requestingFilesDownload){
                return;
            }

            const enabled = await this.ensureDownloadsEnabled();
            if(!enabled){
                return;
            }

            this.requestingFilesDownload = true;

            try{
                const filters = {
                    ...this.filters,
                    nature: this.nature,
                    group: this.tab,
                    period: this.filters.period || this.period,
                };

                const response = await ws.requestCfdiFilesDownload(this.rfc, this.nature, filters, { skipLoading: true });

                if(response && response.type === 'success'){
                    this.$toast.success(response?.message || 'La solicitud de descarga se registró correctamente.');
                    return;
                }

                this.$toast.error(response?.message || 'No fue posible registrar la solicitud de descarga.');
            }
            catch(error){
                this.$toast.error(error?.response?.data?.message || 'No fue posible registrar la solicitud de descarga.');
            }
            finally{
                this.requestingFilesDownload = false;
            }
        },
        async exportCfdis() {
            const filters = {
                ...this.filters,
                nature: this.nature,
                group: this.tab,
                period: this.filters.period || this.period,
            };

            try {
                const response = await ws.exportCfdis(this.rfc, filters, this.available_fields || this.fields || []);
                const blob = response instanceof Blob
                    ? response
                    : new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

                const dateLabel = new Date().toISOString().slice(0, 10);
                const fileName = `cfdis-recibidos-${this.tab}-${dateLabel}.xlsx`;

                const blobUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
            } catch (error) {
                const message = error?.response?.data?.message || 'No fue posible exportar el listado.';
                this.$toast.error(message);
            }
        },
        async onColumnsSave(newConfig) {
            this.columnsConfig = newConfig;

            let response = await ws.setFields(this.nature, this.tab, this.columnsConfig);

            this.fields = this.columnsConfig
        },
        formatInteger(value){
            return Number(value || 0).toLocaleString('es-MX');
        },
        formatCurrency(value){
            return Number(value || 0).toLocaleString('es-MX', {
                style: 'currency',
                currency: 'MXN',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        kpiValueStyle(value) {
            const amount = Math.abs(Number(value || 0));
            const hasPayroll = this.hasPayrollCfdis();
            const width = Number(this.viewportWidth || window.innerWidth || 1920);

            if(hasPayroll){
                if(width <= 1400){
                    if(amount >= 1000000){
                        return { fontSize: '16px' };
                    }

                    if(amount >= 100000){
                        return { fontSize: '18px' };
                    }

                    return { fontSize: '20px' };
                }

                if(width <= 1600){
                    if(amount >= 1000000){
                        return { fontSize: '18px' };
                    }

                    if(amount >= 100000){
                        return { fontSize: '20px' };
                    }

                    return { fontSize: '22px' };
                }

                if(amount >= 1000000){
                    return { fontSize: '20px' };
                }

                if(amount >= 100000){
                    return { fontSize: '22px' };
                }

                return { fontSize: '24px' };
            }

            if(width <= 1400){
                if(amount >= 1000000){
                    return { fontSize: '22px' };
                }

                if(amount >= 100000){
                    return { fontSize: '24px' };
                }

                return { fontSize: '26px' };
            }

            if(width <= 1600){
                if(amount >= 1000000){
                    return { fontSize: '22px' };
                }

                if(amount >= 100000){
                    return { fontSize: '25px' };
                }

                return { fontSize: '27px' };
            }

            if(amount >= 1000000){
                return { fontSize: '22px' };
            }

            if(amount >= 100000){
                return { fontSize: '26px' };
            }

            return { fontSize: '28px' };
        },
        kpiColumnClass() {
            const visibleCount = 3 + (this.shouldShowRetainedKpi() ? 1 : 0) + (this.shouldShowPayrollKpi() ? 1 : 0);

            if(visibleCount <= 3){
                return 'col-sm-12 col-md-4 col-xl-4';
            }

            if(visibleCount === 4){
                return 'col-sm-12 col-md-6 col-xl-3';
            }

            return 'col-sm-12 col-md-6 col-xl-4';
        },
        shouldShowPayrollKpi() {
            return Number(this.kpis?.payroll_total ?? 0) !== 0;
        },
        shouldShowRetainedKpi() {
            return Number(this.kpis?.impuestos_retenidos ?? 0) !== 0;
        },
        hasPayrollCfdis() {
            const payrollCfdis = Number(this.kpis?.payroll_cfdis ?? this.counters?.N ?? 0);
            return payrollCfdis > 0;
        },
        hasFirstKpiBreakdownData() {
            const breakdown = this.kpis?.main_total_breakdown || {};
            const incomePueTotal = Number(breakdown.income_pue_total || 0);
            const incomePpdTotal = Number(breakdown.income_ppd_total || 0);
            const creditNotesTotal = Number(breakdown.credit_notes_total || 0);

            return incomePueTotal !== 0 || incomePpdTotal !== 0 || creditNotesTotal !== 0;
        },
        toggleFirstKpiPopover() {
            const button = this.$refs.firstKpiPopoverBtn;
            if(!button){
                return;
            }

            if(!this.hasFirstKpiBreakdownData()){
                return;
            }

            if(this.firstKpiPopover){
                return;
            }

            this.disposeSecondKpiPopover();
            this.disposeThirdKpiPopover();
            this.disposeFourthKpiPopover();
            this.disposeFirstKpiPopover();
            this.firstKpiPopover = new Popover(button, {
                trigger: 'manual',
                html: true,
                sanitize: false,
                placement: 'bottom',
                container: 'body',
                customClass: 'kpi-breakdown-popover',
                title: 'CFDIs Recibidos',
                content: this.getFirstKpiPopoverContent(),
            });
            this.firstKpiPopover.show();
            const firstPopoverEl = document.querySelector('.kpi-breakdown-popover');
            if(firstPopoverEl){
                firstPopoverEl.addEventListener('mouseenter', this.cancelFirstKpiHide);
                firstPopoverEl.addEventListener('mouseleave', this.scheduleFirstKpiHide);
            }
        },
        disposeFirstKpiPopover() {
            this.cancelFirstKpiHide();
            if(this.firstKpiPopover){
                this.firstKpiPopover.dispose();
                this.firstKpiPopover = null;
            }

            const button = this.$refs.firstKpiPopoverBtn;
            if(button){
                button.removeAttribute('aria-describedby');
            }
        },
        hasSecondKpiBreakdownData() {
            const breakdown = this.kpis?.paid_total_breakdown || {};
            const incomePueTotal = Number(breakdown.income_pue_total || 0);
            const paymentsTotal = Number(breakdown.payments_total || 0);
            const creditNotesTotal = Number(breakdown.credit_notes_total || 0);

            return incomePueTotal !== 0 || paymentsTotal !== 0 || creditNotesTotal !== 0;
        },
        toggleSecondKpiPopover() {
            const button = this.$refs.secondKpiPopoverBtn;
            if(!button){
                return;
            }

            if(!this.hasSecondKpiBreakdownData()){
                return;
            }

            if(this.secondKpiPopover){
                return;
            }

            this.disposeFirstKpiPopover();
            this.disposeThirdKpiPopover();
            this.disposeFourthKpiPopover();
            this.disposeSecondKpiPopover();
            this.secondKpiPopover = new Popover(button, {
                trigger: 'manual',
                html: true,
                sanitize: false,
                placement: 'bottom',
                container: 'body',
                customClass: 'kpi-paid-breakdown-popover',
                title: 'CFDIs Pagados',
                content: this.getSecondKpiPopoverContent(),
            });
            this.secondKpiPopover.show();
            const secondPopoverEl = document.querySelector('.kpi-paid-breakdown-popover');
            if(secondPopoverEl){
                secondPopoverEl.addEventListener('mouseenter', this.cancelSecondKpiHide);
                secondPopoverEl.addEventListener('mouseleave', this.scheduleSecondKpiHide);
            }
        },
        disposeSecondKpiPopover() {
            this.cancelSecondKpiHide();
            if(this.secondKpiPopover){
                this.secondKpiPopover.dispose();
                this.secondKpiPopover = null;
            }

            const button = this.$refs.secondKpiPopoverBtn;
            if(button){
                button.removeAttribute('aria-describedby');
            }
        },
        hasThirdKpiBreakdownData() {
            const breakdown = this.kpis?.paid_iva_breakdown || {};
            const iva16 = Number(breakdown.iva_16_total || 0);
            const iva8 = Number(breakdown.iva_8_total || 0);

            return iva16 !== 0 || iva8 !== 0;
        },
        toggleThirdKpiPopover() {
            const button = this.$refs.thirdKpiPopoverBtn;
            if(!button){
                return;
            }

            if(!this.hasThirdKpiBreakdownData()){
                return;
            }

            if(this.thirdKpiPopover){
                return;
            }

            this.disposeFirstKpiPopover();
            this.disposeSecondKpiPopover();
            this.disposeThirdKpiPopover();
            this.disposeFourthKpiPopover();

            this.thirdKpiPopover = new Popover(button, {
                trigger: 'manual',
                html: true,
                sanitize: false,
                placement: 'bottom',
                container: 'body',
                customClass: 'kpi-iva-breakdown-popover',
                title: 'IVA Acreditable',
                content: this.getThirdKpiPopoverContent(),
            });
            this.thirdKpiPopover.show();
            const thirdPopoverEl = document.querySelector('.kpi-iva-breakdown-popover');
            if(thirdPopoverEl){
                thirdPopoverEl.addEventListener('mouseenter', this.cancelThirdKpiHide);
                thirdPopoverEl.addEventListener('mouseleave', this.scheduleThirdKpiHide);
            }
        },
        disposeThirdKpiPopover() {
            this.cancelThirdKpiHide();
            if(this.thirdKpiPopover){
                this.thirdKpiPopover.dispose();
                this.thirdKpiPopover = null;
            }

            const button = this.$refs.thirdKpiPopoverBtn;
            if(button){
                button.removeAttribute('aria-describedby');
            }
        },
        hasFourthKpiBreakdownData() {
            const breakdownRows = this.kpis?.impuestos_retenidos_breakdown?.rows || [];
            return Array.isArray(breakdownRows) && breakdownRows.some((row) => Number(row?.amount || 0) !== 0);
        },
        toggleFourthKpiPopover() {
            const button = this.$refs.fourthKpiPopoverBtn;
            if(!button){
                return;
            }

            if(!this.hasFourthKpiBreakdownData()){
                return;
            }

            if(this.fourthKpiPopover){
                return;
            }

            this.disposeFirstKpiPopover();
            this.disposeSecondKpiPopover();
            this.disposeThirdKpiPopover();
            this.disposeFourthKpiPopover();

            this.fourthKpiPopover = new Popover(button, {
                trigger: 'manual',
                html: true,
                sanitize: false,
                placement: 'bottom',
                container: 'body',
                customClass: 'kpi-retained-breakdown-popover',
                title: 'Impuestos retenidos',
                content: this.getFourthKpiPopoverContent(),
            });
            this.fourthKpiPopover.show();
            const fourthPopoverEl = document.querySelector('.kpi-retained-breakdown-popover');
            if(fourthPopoverEl){
                fourthPopoverEl.addEventListener('mouseenter', this.cancelFourthKpiHide);
                fourthPopoverEl.addEventListener('mouseleave', this.scheduleFourthKpiHide);
            }
        },
        disposeFourthKpiPopover() {
            this.cancelFourthKpiHide();
            if(this.fourthKpiPopover){
                this.fourthKpiPopover.dispose();
                this.fourthKpiPopover = null;
            }

            const button = this.$refs.fourthKpiPopoverBtn;
            if(button){
                button.removeAttribute('aria-describedby');
            }
        },
        handleKpiPopoverOutsideClick(event) {
            const firstButton = this.$refs.firstKpiPopoverBtn;
            const secondButton = this.$refs.secondKpiPopoverBtn;
            const thirdButton = this.$refs.thirdKpiPopoverBtn;
            const fourthButton = this.$refs.fourthKpiPopoverBtn;
            const firstPopoverEl = document.querySelector('.kpi-breakdown-popover');
            const secondPopoverEl = document.querySelector('.kpi-paid-breakdown-popover');
            const thirdPopoverEl = document.querySelector('.kpi-iva-breakdown-popover');
            const fourthPopoverEl = document.querySelector('.kpi-retained-breakdown-popover');

            if(
                (firstButton && firstButton.contains(event.target)) ||
                (secondButton && secondButton.contains(event.target)) ||
                (firstPopoverEl && firstPopoverEl.contains(event.target)) ||
                (secondPopoverEl && secondPopoverEl.contains(event.target)) ||
                (thirdButton && thirdButton.contains(event.target)) ||
                (thirdPopoverEl && thirdPopoverEl.contains(event.target)) ||
                (fourthButton && fourthButton.contains(event.target)) ||
                (fourthPopoverEl && fourthPopoverEl.contains(event.target))
            ){
                return;
            }

            this.disposeFirstKpiPopover();
            this.disposeSecondKpiPopover();
            this.disposeThirdKpiPopover();
            this.disposeFourthKpiPopover();
        },
        getFirstKpiPopoverContent() {
            const breakdown = this.kpis?.main_total_breakdown || {};
            const incomePueTotal = Number(breakdown.income_pue_total || 0);
            const incomePpdTotal = Number(breakdown.income_ppd_total || 0);
            const creditNotesTotal = Number(breakdown.credit_notes_total || 0);

            return this.renderKpiBreakdownTable(
                [
                    {
                        label: 'Facturas de contado',
                        detailKey: 'received_income_pue',
                        detailTitle: 'CFDIs Recibidos - Facturas de contado',
                        sign: '+',
                        subtotal: Number(breakdown.income_pue_subtotal ?? incomePueTotal),
                        transferred: Number(breakdown.income_pue_transferred ?? 0),
                        retained: Number(breakdown.income_pue_retained ?? 0),
                        total: incomePueTotal,
                    },
                    {
                        label: 'Facturas a crédito',
                        detailKey: 'received_income_ppd',
                        detailTitle: 'CFDIs Recibidos - Facturas a crédito',
                        sign: '+',
                        subtotal: Number(breakdown.income_ppd_subtotal ?? incomePpdTotal),
                        transferred: Number(breakdown.income_ppd_transferred ?? 0),
                        retained: Number(breakdown.income_ppd_retained ?? 0),
                        total: incomePpdTotal,
                    },
                    {
                        label: 'Notas de crédito',
                        detailKey: 'received_credit_notes',
                        detailTitle: 'CFDIs Recibidos - Notas de crédito',
                        sign: '-',
                        subtotal: Number(breakdown.credit_notes_subtotal ?? creditNotesTotal),
                        transferred: Number(breakdown.credit_notes_transferred ?? 0),
                        retained: Number(breakdown.credit_notes_retained ?? 0),
                        total: creditNotesTotal,
                    },
                ],
                {
                    subtotal: Number(breakdown.net_subtotal ?? breakdown.net_total ?? 0),
                    transferred: Number(breakdown.net_transferred ?? 0),
                    retained: Number(breakdown.net_retained ?? 0),
                    total: Number(breakdown.net_total ?? 0),
                },
                { interactiveTotals: true }
            );
        },
        getSecondKpiPopoverContent() {
            const breakdown = this.kpis?.paid_total_breakdown || {};
            const incomePueTotal = Number(breakdown.income_pue_total || 0);
            const paymentsTotal = Number(breakdown.payments_total || 0);
            const creditNotesTotal = Number(breakdown.credit_notes_total || 0);

            return this.renderKpiBreakdownTable(
                [
                    {
                        label: 'Facturas de contado',
                        detailKey: 'paid_income_pue',
                        detailTitle: 'CFDIs Pagados - Facturas de contado',
                        sign: '+',
                        subtotal: Number(breakdown.income_pue_subtotal ?? incomePueTotal),
                        transferred: Number(breakdown.income_pue_transferred ?? 0),
                        retained: Number(breakdown.income_pue_retained ?? 0),
                        total: incomePueTotal,
                    },
                    {
                        label: 'Facturas a crédito',
                        detailKey: 'paid_payments',
                        detailTitle: 'CFDIs Pagados - Facturas a crédito',
                        sign: '+',
                        subtotal: Number(breakdown.payments_subtotal ?? paymentsTotal),
                        transferred: Number(breakdown.payments_transferred ?? 0),
                        retained: Number(breakdown.payments_retained ?? 0),
                        total: paymentsTotal,
                    },
                    {
                        label: 'Notas de crédito',
                        detailKey: 'paid_credit_notes',
                        detailTitle: 'CFDIs Pagados - Notas de crédito',
                        sign: '-',
                        subtotal: Number(breakdown.credit_notes_subtotal ?? creditNotesTotal),
                        transferred: Number(breakdown.credit_notes_transferred ?? 0),
                        retained: Number(breakdown.credit_notes_retained ?? 0),
                        total: creditNotesTotal,
                    },
                ],
                {
                    subtotal: Number(breakdown.net_subtotal ?? breakdown.net_total ?? 0),
                    transferred: Number(breakdown.net_transferred ?? 0),
                    retained: Number(breakdown.net_retained ?? 0),
                    total: Number(breakdown.net_total ?? 0),
                },
                { interactiveTotals: true }
            );
        },
        getThirdKpiPopoverContent() {
            const breakdown = this.kpis?.paid_iva_breakdown || {};
            const iva16Total = Number(breakdown.iva_16_total || 0);
            const iva8Total = Number(breakdown.iva_8_total || 0);
            const incomePue = breakdown.income_pue || {};
            const payments = breakdown.payments || {};
            const creditNotes = breakdown.credit_notes || {};

            const netTotal = this.formatCurrency(breakdown.net_total);

            const sectionRows = [];
            const addSourceSection = (label, source, sign, detailPrefix) => {
                const sourceIva16 = Number(source.iva_16 || 0);
                const sourceIva8 = Number(source.iva_8 || 0);
                const sourceNet = Number(source.net_total || 0);

                if(sourceIva16 === 0 && sourceIva8 === 0){
                    return;
                }

                const sourceSign = sign === '-' ? '-' : '+';
                sectionRows.push(`<div class="kpi-popover-row"><span><strong>${label}: </strong></span><strong style="float: right;"></strong></div>`);

                if(sourceIva16 !== 0){
                    sectionRows.push(`<div class="kpi-popover-row" style="padding-left: 12px;"><span>IVA 16%: </span>${this.renderKpiAmountButton(`${detailPrefix}_16`, `IVA Acreditable - ${label} IVA 16%`, sourceIva16, sourceSign)}</div>`);
                }

                if(sourceIva8 !== 0){
                    sectionRows.push(`<div class="kpi-popover-row" style="padding-left: 12px;"><span>IVA 8%: </span>${this.renderKpiAmountButton(`${detailPrefix}_8`, `IVA Acreditable - ${label} IVA 8%`, sourceIva8, sourceSign)}</div>`);
                }
            };

            addSourceSection('Facturas de contado', incomePue, '+', 'iva_income_pue');
            addSourceSection('Facturas a crédito', payments, '+', 'iva_payments');
            addSourceSection('Notas de Crédito', creditNotes, '-', 'iva_credit_notes');

            const totalsRows = [];
            if(iva16Total !== 0){
                totalsRows.push(`<div class="kpi-popover-row"><span>IVA 16% Total: </span>${this.renderKpiAmountButton('iva_total_16', 'IVA Acreditable - IVA 16% Total', iva16Total, '+')}</div>`);
            }

            if(iva8Total !== 0){
                totalsRows.push(`<div class="kpi-popover-row"><span>IVA 8% Total: </span>${this.renderKpiAmountButton('iva_total_8', 'IVA Acreditable - IVA 8% Total', iva8Total, '+')}</div>`);
            }

            const rowsHtml = sectionRows.join('');
            const totalsHtml = totalsRows.join('');
            const dividerHtml = sectionRows.length > 0
                ? '<div class="kpi-popover-divider" style="text-align: right;">----------------</div>'
                : '';
            const totalsDividerHtml = totalsRows.length > 0
                ? '<div class="kpi-popover-divider" style="text-align: right;">----------------</div>'
                : '';

            return `
                <div class="kpi-popover-content" style="min-width: 250px;">
                    ${rowsHtml}
                    ${dividerHtml}
                    <div class="kpi-popover-row is-result"><span>Total: </span><strong style="float: right;">${netTotal}</strong></div>
                </div>
            `;
        },
        getFourthKpiPopoverContent() {
            const breakdown = this.kpis?.impuestos_retenidos_breakdown || {};
            const rows = Array.isArray(breakdown.rows) ? breakdown.rows : [];
            const total = Number(breakdown.total ?? this.kpis?.impuestos_retenidos ?? 0);

            const rowHtml = rows
                .filter((row) => Number(row?.amount || 0) !== 0)
                .map((row) => {
                    const amount = Number(row?.amount || 0);
                    const sign = amount < 0 ? '-' : '+';
                    const label = `${row?.tax_name || 'Impuesto'} ${row?.rate_percent || ''}`.trim();

                    return `<div class="kpi-popover-row ${amount < 0 ? 'is-negative' : ''}"><span>${label}: </span><strong style="float: right;">${sign} ${this.formatCurrency(Math.abs(amount))}</strong></div>`;
                })
                .join('');

            const dividerHtml = rowHtml
                ? '<div class="kpi-popover-divider" style="text-align: right;">----------------</div>'
                : '';

            return `
                <div class="kpi-popover-content" style="min-width: 250px;">
                    ${rowHtml}
                    ${dividerHtml}
                    <div class="kpi-popover-row is-result"><span>Total: </span><strong style="float: right;">${this.formatCurrency(total)}</strong></div>
                </div>
            `;
        }
    },
    computed: {
        pagesToShow () {
            const total = this.paginator.total_pages
            const current = this.paginator.current_page
            const delta = 2 // cuántas antes y después

            if (total === 0) return []

            let start = current - delta
            let end = current + delta

            // Ajustar si el inicio se va abajo de 1
            if (start < 1) {
            end = Math.min(end + (1 - start), total)
            start = 1
            }

            // Ajustar si el final se pasa del total
            if (end > total) {
            start = Math.max(1, start - (end - total))
            end = total
            }

            const pages = []
            for (let i = start; i <= end; i++) {
            pages.push(i)
            }
            return pages
        },
        hasAdvancedFilters () {
            return this.advancedFilters.length > 0
        }
    }
}
</script>
<style scoped>
    .card .card-header {
        padding-top: 20px !important;
        padding-bottom: 10px !important;
    }

    .kpi-row{
        margin-bottom: 14px;
    }

    .kpi-card{
        --kpi-accent: var(--theme-deafult, #3f7ee8);
        border: 1px solid var(--sidebar-border);
        border-radius: 12px;
        background: var(--white);
        padding: 14px 16px;
        margin-bottom: 12px;
        position: relative;
        overflow: hidden;
        transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
    }

    .kpi-card::before{
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 3px;
        background: linear-gradient(90deg, var(--kpi-accent), transparent);
        opacity: 0.9;
    }

    .kpi-card::after{
        content: '';
        position: absolute;
        top: -34px;
        right: -34px;
        width: 96px;
        height: 96px;
        border-radius: 50%;
        background: radial-gradient(circle, color-mix(in srgb, var(--kpi-accent) 22%, transparent) 0%, transparent 70%);
        pointer-events: none;
    }

    .kpi-card-hoverable:hover{
        transform: translateY(-2px);
        border-color: color-mix(in srgb, var(--kpi-accent) 42%, var(--sidebar-border));
        box-shadow: 0 8px 20px color-mix(in srgb, var(--kpi-accent) 18%, transparent);
    }

    .kpi-card-hoverable{
        cursor: help;
    }

    .kpi-card--primary{
        --kpi-accent: var(--theme-deafult, #3f7ee8);
    }

    .kpi-card--success{
        --kpi-accent: var(--theme-secondary, #25a86c);
    }

    .kpi-card--info{
        --kpi-accent: var(--theme-deafult, #3f7ee8);
    }

    .kpi-card--warning{
        --kpi-accent: #c7891f;
    }

    .kpi-card--payroll{
        --kpi-accent: var(--theme-secondary, #25a86c);
    }

    .kpi-card-top{
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
    }

    .kpi-title{
        font-size: 12px;
        font-weight: 600;
        color: var(--theme-font-color);
        opacity: 0.75;
        margin-bottom: 4px;
    }

    .kpi-value{
        font-size: 28px;
        line-height: 1;
        font-weight: 700;
        color: var(--theme-font-color);
    }

    .kpi-footnote{
        margin-top: 8px;
        font-size: 11px;
        color: var(--theme-font-color);
        opacity: 0.72;
    }

    .kpi-loading-note{
        margin-top: 4px;
        font-size: 10px;
        color: var(--theme-font-color);
        opacity: 0.6;
    }

    .kpi-icon{
        width: 32px;
        height: 32px;
        border-radius: 8px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
    }

    .kpi-icon-button{
        border: none;
        cursor: pointer;
        transition: transform 0.2s ease;
    }

    .kpi-icon-button:hover{
        transform: translateY(-1px);
    }

    .kpi-icon-button:disabled{
        opacity: 0.45;
        cursor: not-allowed;
        transform: none;
    }

    .kpi-icon-blue{
        background: var(--sidebar-border);
        color: var(--theme-deafult);
    }

    .kpi-icon-green{
        background: var(--sidebar-border);
        color: var(--theme-secondary);
    }

    .kpi-icon-cyan{
        background: var(--sidebar-border);
        color: var(--theme-deafult);
    }

    .nav-link{
        font-size: 12px !important;
    }

    .creditable-breakdown-wrapper{
        border: 1px solid var(--sidebar-border);
        border-radius: 10px;
        background: var(--white);
    }

    .creditable-breakdown-table th,
    .creditable-breakdown-table td{
        font-size: 12px;
        vertical-align: middle;
        white-space: nowrap;
    }

    .creditable-breakdown-table thead th{
        background: #f8f8ff;
        color: var(--theme-font-color);
        font-weight: 600;
    }

    .creditable-breakdown-table .is-total-row td{
        font-weight: 700;
    }

    .creditable-total-cell{
        color: #2997d6;
        font-weight: 600;
    }

    :deep(.kpi-popover-row){
        display: flex;
        align-items: center;
        font-size: 11px;
        line-height: 1.2;
        margin-bottom: 6px;
        color: var(--theme-font-color);
    }

    :deep(.kpi-popover-row span){
        padding-right: 12px;
        white-space: nowrap;
    }

    :deep(.kpi-popover-row strong){
        margin-left: auto;
        text-align: right;
        font-weight: 700;
        font-size: 11px;
        font-variant-numeric: tabular-nums;
        white-space: nowrap;
    }

    :deep(.kpi-popover-row.is-negative strong){
        color: #d9534f;
    }

    :deep(.kpi-popover-row.is-result){
        margin-top: 4px;
    }

    :deep(.kpi-popover-row.is-result strong){
        color: var(--theme-deafult);
    }

    :deep(.kpi-popover-divider){
        border-top: 1px solid var(--sidebar-border);
        margin: 8px 0;
    }

    :deep(.kpi-popover-table){
        margin-bottom: 0;
    }

    :deep(.kpi-popover-table th),
    :deep(.kpi-popover-table td){
        font-size: 10px;
        white-space: nowrap;
        vertical-align: middle;
    }

    :deep(.kpi-popover-amount-btn){
        font-size: 11px;
        white-space: nowrap;
    }

    @media (max-width: 1400px){
        :deep(.kpi-popover-row){
            font-size: 10px;
        }

        :deep(.kpi-popover-row strong),
        :deep(.kpi-popover-amount-btn){
            font-size: 10px;
        }

        :deep(.kpi-popover-table th),
        :deep(.kpi-popover-table td){
            font-size: 9px;
        }
    }

    :deep(.kpi-popover-table thead th){
        background: #f8f8ff;
        font-weight: 700;
    }

    :deep(.kpi-popover-table tbody tr.is-negative td),
    :deep(.kpi-popover-table tbody tr.is-negative strong),
    :deep(.kpi-popover-table tbody tr.is-negative .kpi-popover-amount-btn){
        color: #d9534f;
    }

    :deep(.kpi-popover-table tfoot th){
        border-top: 2px solid var(--sidebar-border);
        font-weight: 700;
        background: #fbfdff;
    }

</style>